import React from 'react'
import Lottie from 'react-lottie';
import * as animationData from '@gifs/done.json'

function DoneGif({width, height, loop = false}) {

    const defaultOptions = {
        width: width ?? 24,
        height: height ?? 24,
        loop: loop,
        autoplay: true,
        animationData: animationData.default,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    return (
        <Lottie
            options={defaultOptions}
            width={width ?? 24}
            height={height ?? 24}
            isClickToPauseDisabled={true}
        />
    )
}

export default React.memo(DoneGif);